import React, { useState, useEffect } from "react";
import { useAppSelector, useAppDispatch } from "../../app/hooks";
import { selectAddress } from "../address/addressSlice";
import {
  fetchStreetViewImagesAction,
  selectStreetViewImages,
  fetchSatelliteImageAction,
  selectSatelliteImage,
} from "../address/addressSlice";
import {
  selectGraffitiModelData,
  fetchGraffitiModelDataAction,
  selectWalledWindowModelData,
  fetchWalledWindowModelDataAction,
  selectPoolModelData,
  selectSolarPanelModellData,
  fetchPoolModelDataAction,
  fetchSolarPanelModelDataAction,
  setAiModelSelection,
  selectAIModelSelection,
} from "../address/aiDetectionSlice";
import {
  createOrUpdateUserAnnotationAction,
  fetchUserAnnotationAction,
  selectUserAnnotation,
} from "../userAnnotation/userAnnotationSlice";
import { regionImage, segmentationImage } from "../address/CanvasService";
import { CircularProgress, Box, Typography, Divider, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import FullscreenIcon from "@mui/icons-material/Fullscreen";
import NoImages from "../../assets/no-images.png";
import Carousel from "../../components/Carousel";
import AiModelResultInfos from "../../components/AiModelResultInfos";
import { ResultBlockType } from "../../types";
import Grid from "@mui/material/Grid";
import FormNote, { AnswerList } from "../../components/FormNote";
import SatelliteSearchResultBlock from "./SatelliteSearchResultBlock";
import StreetViewSearchResultBlock from "./StreetViewSearchResultBlock";
import Icon from "../../components/Icon";

import PanoramaxViewer from '../../components/Panoramax';
// import '@panoramax/web-viewer/build/index.css';

import "./CombinedImageSearchResultBlock.css";

// function getImageCorners(
//   centerLongitude: number,
//   centerLatitude: number,
//   zoom: number,
//   imageWidthPixels: number,
//   imageHeightPixels: number
// ) {
//   // Calculate scale
//   const scale =
//     (156543.03392 * Math.cos((centerLatitude * Math.PI) / 180)) / 2 ** zoom;

//   // Calculate width and height in meters
//   const widthMeters = scale * imageWidthPixels;
//   const heightMeters = scale * imageHeightPixels;

//   // Calculate relative coordinates of corners in meters
//   const northMeters = heightMeters / 2;
//   const southMeters = -heightMeters / 2;
//   const eastMeters = widthMeters / 2;
//   const westMeters = -widthMeters / 2;

//   // Convert relative coordinates to absolute coordinates
//   const northLatitude = centerLatitude + northMeters / 111319.9;
//   const southLatitude = centerLatitude + southMeters / 111319.9;
//   const eastLongitude =
//     centerLongitude +
//     eastMeters / (111319.9 * Math.cos((centerLatitude * Math.PI) / 180));
//   const westLongitude =
//     centerLongitude +
//     westMeters / (111319.9 * Math.cos((centerLatitude * Math.PI) / 180));

//   // Return coordinates of corners
//   return { northLatitude, southLatitude, eastLongitude, westLongitude };
// }

export default function CombinedImageSearchResultBlock(item: ResultBlockType) {
//   const dispatch = useAppDispatch();
  const address = useAppSelector(selectAddress);
  const streetViewImagesState = useAppSelector(selectStreetViewImages);
  let streetViewHeading = Math.round(streetViewImagesState?.value?.heading || 0);
  const [isStreetViewFullscreen, setIsStreetViewFullscreen] = useState(false);
  const [isPanoramaxFullscreen, setIsPanoramaxFullscreen] = useState(false);
//   const satelliteImage = useAppSelector(selectSatelliteImage);
//   const userAnnotation = useAppSelector(selectUserAnnotation);

  // Close overlays on Escape key
  useEffect(() => {
    const handleEscape = (event: KeyboardEvent) => {
      if (event.key === "Escape") {
        if (isStreetViewFullscreen) {
          setIsStreetViewFullscreen(false);
        }
        if (isPanoramaxFullscreen) {
          setIsPanoramaxFullscreen(false);
        }
      }
    };

    const isAnyOverlayOpen = isStreetViewFullscreen || isPanoramaxFullscreen;
    if (isAnyOverlayOpen) {
      document.addEventListener("keydown", handleEscape);
      // Prevent body scroll when overlay is open
      document.body.style.overflow = "hidden";
    }

    return () => {
      document.removeEventListener("keydown", handleEscape);
      document.body.style.overflow = "unset";
    };
  }, [isStreetViewFullscreen, isPanoramaxFullscreen]);

  // Build Panoramax viewer URL with address coordinates
  const panoramaxViewerUrl = address?.value?.latitude && address?.value?.longitude
    ? `https://api.panoramax.xyz/?s=fp;s1;pa3b26c89-d4a8-4ab6-ab70-6319df654ebc;c180.54/-7.98/30;m17/${address.value.latitude}/${address.value.longitude}`
    : "https://viewer.geovisio.fr/?lat=48.8584&lon=2.2945&catalog=https://api.panoramax.xyz/api";

//   // Street View states
//   const [aiGraffitiImageURL, setAiGraffitimageURL] = useState<any>(null);
//   const [aiWalledWindowImageURL, setAiIWalledWindowmageURL] = useState<any>(null);
//   const [graffitiModelMaskVisibility, setGraffitiModelMaskVisibility] = useState<boolean>(false);
//   const [walledWindowModelMaskVisibility, setWalledWindowModelMaskVisibility] = useState<boolean>(false);

//   // Satellite states
//   const [aiPoolImageURL, setAiIPoolmageURL] = useState<any>(null);
//   const [aiSolarPanelImageURL, setAiISolarPanelmageURL] = useState<any>(null);
//   const [imgGeoshapeUrl, setImgGeoshapeUrl] = useState<any>(null);
//   const [solarPanelModelMaskVisibility, setSolarPanelModelMaskVisibility] = useState<boolean>(false);
//   const [poolMaskVisibility, setPoolModelMaskVisibility] = useState<boolean>(false);

//   // AI model data
//   const graffiti = useAppSelector(selectGraffitiModelData);
//   const walledWindow = useAppSelector(selectWalledWindowModelData);
//   const solarPanel = useAppSelector(selectSolarPanelModellData);
//   const pool = useAppSelector(selectPoolModelData);
//   const aiModelSelection = useAppSelector(selectAIModelSelection);


//   // Form states
//   const [streetViewQuestionList, setStreetViewQuestionList] = useState<AnswerList>({
//     graffiti: null,
//     walled_window: null,
//     facade_crack: null,
//   });

//   const [satelliteQuestionList, setSatelliteQuestionList] = useState<AnswerList>({
//     pool: null,
//     solar_panel: null,
//     roof_condition: null,
//   });

//   // Fetch data effects
//   useEffect(() => {
//     if (address?.value) {
//       dispatch(fetchStreetViewImagesAction(address?.value?.placeId));
//       dispatch(fetchSatelliteImageAction(address?.value?.placeId));
//     }
//   }, [dispatch, address?.value]);

//   useEffect(() => {
//     if (address?.value) {
//       dispatch(fetchUserAnnotationAction(address?.value?.placeId));
//     }
//   }, [dispatch, address?.value]);

//   // Street View AI model effects
//   const graffitySectionState = aiModelSelection["graffiti"];
//   useEffect(() => {
//     if (!streetViewImages.value) {
//       return;
//     }
//     if (graffitySectionState) {
//       dispatch(fetchGraffitiModelDataAction());
//     }
//   }, [graffitySectionState, dispatch, streetViewImages.value]);

//   const walledWindowSelectionState = aiModelSelection["walledWindow"];
//   useEffect(() => {
//     if (!streetViewImages.value) {
//       return;
//     }
//     if (walledWindowSelectionState) {
//       dispatch(fetchWalledWindowModelDataAction());
//     }
//   }, [walledWindowSelectionState, dispatch, streetViewImages.value]);

//   // Satellite AI model effects
//   const solaPanelSelectionState = aiModelSelection["solarPanel"];
//   useEffect(() => {
//     if (!satelliteImage?.value) {
//       return;
//     }
//     if (solaPanelSelectionState) {
//       dispatch(fetchSolarPanelModelDataAction());
//     }
//   }, [solaPanelSelectionState, dispatch, satelliteImage?.value]);

//   const poolSelectionState = aiModelSelection["pool"];
//   useEffect(() => {
//     if (!satelliteImage?.value) {
//       return;
//     }
//     if (poolSelectionState) {
//       dispatch(fetchPoolModelDataAction());
//     }
//   }, [poolSelectionState, dispatch, satelliteImage?.value]);

//   // Street View image processing effects
//   useEffect(() => {
//     (async function () {
//       if (!graffiti.value) {
//         setAiGraffitimageURL(null);
//         setGraffitiModelMaskVisibility(false);
//         return;
//       }
//       const imageData = graffiti.value.boxes;
//       const color = { r: 0, g: 255, b: 0, a: 255 };
//       const imageURL = await regionImage(
//         imageData,
//         { width: "640", height: "640" },
//         color
//       );
//       setAiGraffitimageURL(imageURL);
//       setGraffitiModelMaskVisibility(true);
//     })();
//   }, [graffiti]);

//   useEffect(() => {
//     (async function () {
//       if (!walledWindow.value) {
//         setAiIWalledWindowmageURL(null);
//         setWalledWindowModelMaskVisibility(false);
//         return;
//       }
//       const imageData = walledWindow.value.boxes;
//       const color = { r: 0, g: 255, b: 0, a: 255 };
//       const imageURL = await regionImage(
//         imageData,
//         { width: "640", height: "640" },
//         color
//       );
//       setAiIWalledWindowmageURL(imageURL);
//       setWalledWindowModelMaskVisibility(true);
//     })();
//   }, [walledWindow]);

//   // Satellite image processing effects
//   useEffect(() => {
//     (async function () {
//       if (!pool.value) {
//         setAiIPoolmageURL(null);
//         setPoolModelMaskVisibility(false);
//         return;
//       }
//       const imageData = pool.value.matrix;
//       const color = { r: 255, g: 0, b: 0, a: 255 };
//       const imageURL = await segmentationImage(imageData, color);
//       setAiIPoolmageURL(imageURL);
//       setPoolModelMaskVisibility(true);
//     })();
//   }, [pool]);

//   useEffect(() => {
//     (async function () {
//       if (!solarPanel.value) {
//         setAiISolarPanelmageURL(null);
//         setSolarPanelModelMaskVisibility(false);
//         return;
//       }
//       const imageData = solarPanel.value.boxes;
//       const color = { r: 255, g: 255, b: 0, a: 255 };
//       const imageURL = await regionImage(
//         imageData,
//         { width: "640", height: "640" },
//         color
//       );
//       setAiISolarPanelmageURL(imageURL);
//       setSolarPanelModelMaskVisibility(true);
//     })();
//   }, [solarPanel]);

//   // User annotation effects
//   useEffect(() => {
//     setStreetViewQuestionList({
//       graffiti:
//         userAnnotation?.value?.note?.street_view?.graffiti !== undefined
//           ? userAnnotation?.value?.note?.street_view.graffiti
//           : null,
//       walled_window:
//         userAnnotation?.value?.note?.street_view?.walled_window !== undefined
//           ? userAnnotation?.value?.note?.street_view.walled_window
//           : null,
//       facade_crack:
//         userAnnotation?.value?.note?.street_view?.facade_crack !== undefined
//           ? userAnnotation?.value?.note?.street_view.facade_crack
//           : null,
//     });
//   }, [userAnnotation.value, address.value]);

//   useEffect(() => {
//     setSatelliteQuestionList({
//       pool:
//         userAnnotation?.value?.note?.satellite?.pool !== undefined
//           ? userAnnotation?.value?.note?.satellite.pool
//           : null,
//       solar_panel:
//         userAnnotation?.value?.note?.satellite?.solar_panel !== undefined
//           ? userAnnotation?.value?.note?.satellite.solar_panel
//           : null,
//       roof_condition:
//         userAnnotation?.value?.note?.satellite?.roof_condition !== undefined
//           ? userAnnotation?.value?.note?.satellite.roof_condition
//           : null,
//     });
//   }, [address.value, userAnnotation.value]);

//   // Handlers

//   const handleModelVisibility = (model: string, value: boolean) => {
//     switch (model) {
//       case "graffiti":
//         setGraffitiModelMaskVisibility(value);
//         break;
//       case "walledWindow":
//         setWalledWindowModelMaskVisibility(value);
//         break;
//       case "pool":
//         setPoolModelMaskVisibility(value);
//         break;
//       case "solarPanel":
//         setSolarPanelModelMaskVisibility(value);
//         break;
//       default:
//     }
//   };

//   const handleFetchGraffitiModel = () => {
//     dispatch(setAiModelSelection("graffiti", true));
//     dispatch(fetchGraffitiModelDataAction({ placeId: address?.value?.placeId }));
//   };

//   const handleFetchWalledWindowModel = () => {
//     dispatch(setAiModelSelection("walledWindow", true));
//     dispatch(fetchWalledWindowModelDataAction({ placeId: address?.value?.placeId }));
//   };

//   const handleFetchPoolModel = () => {
//     dispatch(setAiModelSelection("pool", true));
//     dispatch(fetchPoolModelDataAction());
//   };

//   const handleFetchSolarPanelModel = () => {
//     dispatch(setAiModelSelection("solarPanel", true));
//     dispatch(fetchSolarPanelModelDataAction());
//   };

//   const handleSaveStreetViewAnswers = (updatedAnswers: AnswerList) => {
//     setStreetViewQuestionList(updatedAnswers);
//     const body = {
//       note: {
//         street_view: updatedAnswers,
//       },
//     };
//     dispatch(createOrUpdateUserAnnotationAction(address?.value?.placeId, body));
//   };

//   const handleSaveSatelliteAnswers = (updatedAnswers: AnswerList) => {
//     if (!address?.value?.placeId) {
//       return;
//     }
//     setSatelliteQuestionList(updatedAnswers);
//     const body = {
//       note: {
//         satellite: updatedAnswers,
//       },
//     };
//     dispatch(createOrUpdateUserAnnotationAction(address?.value?.placeId, body));
//   };

//   const drawPolygon = (img: HTMLImageElement) => {
//     const { buildings, latitude: lat, longitude: lng } = address.value;
//     const buildingCoords = buildings.features[0].geometry.coordinates.map(
//       (building: any[]) => building[0]
//     );
//     const zoomLevel = satelliteImage.value.zoomLevel;

//     const width = 640;
//     const height = 640;
//     const scale = 1;
//     const zoom = zoomLevel;

//     const canvas = document.createElement("canvas");
//     const ctx = canvas.getContext("2d");
//     canvas.width = width;
//     canvas.height = height;

//     // Calculate the pixel coordinates of the corners
//     const corners = getImageCorners(
//       lng,
//       lat,
//       zoom,
//       width / scale,
//       height / scale
//     );
//     const { northLatitude, southLatitude, eastLongitude, westLongitude } = corners;

//     // Calculate the latitude and Longitude length on the image
//     const lng_range = eastLongitude - westLongitude;
//     const lat_range = northLatitude - southLatitude;

//     // Functions to convert gps coordinates to spacial coordinates
//     const lngToX = (lng: number) => ((lng - westLongitude) * width) / lng_range;
//     const latToY = (lat: number) => ((lat - southLatitude) * height) / lat_range;
//     const pixelCoords: any[] = [];

//     for (const building of buildingCoords) {
//       const pixelBuilding = building.map(([x, y]: [number, number]) => [
//         lngToX(x),
//         height - latToY(y),
//       ]);
//       pixelCoords.push(pixelBuilding);
//     }

//     if (ctx) {
//       // Draw the polygon
//       for (const pixelBuilding of pixelCoords) {
//         ctx.beginPath();
//         ctx.moveTo(pixelBuilding[0][0], pixelBuilding[0][1]);
//         for (let i = 1; i < pixelBuilding.length; i++) {
//           ctx.lineTo(pixelBuilding[i][0], pixelBuilding[i][1]);
//         }
//         ctx.closePath();
//         ctx.strokeStyle = "blue";
//         ctx.lineWidth = 5;
//         ctx.stroke();
//         ctx.fillStyle = "rgba(0, 0, 255, 0.5)";
//         ctx.fill();
//       }
//     }
//     canvas.toBlob((blob) => {
//       if (!blob) {
//         return;
//       }
//       const url = window.URL.createObjectURL(blob);
//       setImgGeoshapeUrl(url);
//     });
//   };

  return (
    <>
      <Box sx={{ width: "100%", height: "100%", display: "flex", flexDirection: "row", gap: 2 }} className="CombinedImageSearchResultBlock">
          {/* Street View Section */}
          <Box style={{ flex: 1, display: "flex", flexDirection: "column" }}>
              <Typography variant="h6" sx={{ mb: 0.5, fontWeight: 600, display: "flex", alignItems: "center", gap: 1 }}>
                <span>Street View</span>
                <IconButton
                  size="small"
                  onClick={() => setIsStreetViewFullscreen(true)}
                  sx={{ padding: "4px" }}
                  title="Agrandir"
                >
                  <FullscreenIcon />
                </IconButton>
                {/* <IconButton
                  size="small"
                  onClick={() => setIsPanoramaxFullscreen(true)}
                  sx={{ padding: "4px" }}
                  title="Ouvrir Panoramax"
                >
                  <FullscreenIcon fontSize="small" />
                </IconButton> */}
                <a href={`https://www.google.com/maps/@?api=1&map_action=pano&viewpoint=${address?.value?.latitude},${address?.value?.longitude}&heading=${streetViewHeading}&pitch=0&fov=90`} target="_blank" rel="noopener noreferrer">
                  <button className="GoogleMapsButton" style={{ border: "none", background: "transparent", verticalAlign: "baseline" }}><Icon type="google_streetview_icon" containerStyle={{ width: "16px", height: "16px" }} title="Voir sur google street view"/></button>
                </a>
              </Typography>
              <StreetViewSearchResultBlock key={`search_block_street_view`} {...item} className="StreetViewSearchResultBlock"/>
          </Box>

          {/* Satellite Section */}
          <Box style={{ flex: 1, display: "flex", flexDirection: "column" }}>
              <Typography variant="h6" sx={{ mb: 0.5, fontWeight: 600, display: "flex", alignItems: "center", gap: 1 }}>
                <span>Vue satellite</span>
                <a href={`https://www.google.com/maps/@?api=1&map_action=map&center=${address?.value?.latitude},${address?.value?.longitude}&basemap=satellite&zoom=25`} target="_blank" rel="noopener noreferrer">
                  <button className="GoogleMapsButton" style={{ border: "none", background: "transparent", verticalAlign: "baseline" }}><Icon type="google_maps_icon" containerStyle={{ width: "16px", height: "16px" }} title="Voir sur google maps"/></button>
                </a>
              </Typography>
              

              <SatelliteSearchResultBlock key={`search_block_aerial_view`} {...item} className="SatelliteSearchResultBlock"/>
          </Box>
      </Box>

      {/* Fullscreen Overlay for Street View */}
      {isStreetViewFullscreen && (
        <Box
          className="StreetViewFullscreenOverlay"
          onClick={(e) => {
            // Close overlay if clicking on the background (not on the content)
            if (e.target === e.currentTarget) {
              setIsStreetViewFullscreen(false);
            }
          }}
          sx={{
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: "rgba(0, 0, 0, 0.95)",
            zIndex: 9999,
            display: "flex",
            flexDirection: "column",
            padding: 2,
            overflow: "auto",
            cursor: "default",
          }}
        >
          {/* Header with close button */}
          <Box
            onClick={(e) => e.stopPropagation()}
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              marginBottom: 2,
            }}
          >
            <Typography variant="h5" sx={{ color: "white", fontWeight: 600 }}>
              Street View - Vue agrandie
            </Typography>
            <IconButton
              onClick={() => setIsStreetViewFullscreen(false)}
              sx={{
                color: "white",
                backgroundColor: "rgba(255, 255, 255, 0.1)",
                "&:hover": {
                  backgroundColor: "rgba(255, 255, 255, 0.2)",
                },
              }}
            >
              <CloseIcon />
            </IconButton>
          </Box>

          {/* Fullscreen Street View Content */}
          <Box
            onClick={(e) => e.stopPropagation()}
            sx={{
              flex: 1,
              backgroundColor: "rgba(255, 255, 255, 0.05)",
              borderRadius: 2,
              padding: 2,
              overflow: "auto",
              cursor: "default",
            }}
          >
            <StreetViewSearchResultBlock
              key={`search_block_street_view_fullscreen`}
              {...item}
              className="StreetViewSearchResultBlock StreetViewSearchResultBlock--fullscreen"
            />
          </Box>
        </Box>
      )}

      {/* Fullscreen Overlay for Panoramax */}
      {isPanoramaxFullscreen && (
        <Box
          className="PanoramaxFullscreenOverlay"
          onClick={(e) => {
            // Close overlay if clicking on the background (not on the content)
            if (e.target === e.currentTarget) {
              setIsPanoramaxFullscreen(false);
            }
          }}
          sx={{
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: "rgba(0, 0, 0, 0.95)",
            zIndex: 9999,
            display: "flex",
            flexDirection: "column",
            padding: 2,
            overflow: "auto",
            cursor: "default",
          }}
        >
          {/* Header with close button */}
          <Box
            onClick={(e) => e.stopPropagation()}
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              marginBottom: 2,
            }}
          >
            <Typography variant="h5" sx={{ color: "white", fontWeight: 600 }}>
              Panoramax Viewer
            </Typography>
            <IconButton
              onClick={() => setIsPanoramaxFullscreen(false)}
              sx={{
                color: "white",
                backgroundColor: "rgba(255, 255, 255, 0.1)",
                "&:hover": {
                  backgroundColor: "rgba(255, 255, 255, 0.2)",
                },
              }}
            >
              <CloseIcon />
            </IconButton>
          </Box>

          {/* Panoramax iframe Content */}
          <Box
            onClick={(e) => e.stopPropagation()}
            sx={{
              flex: 1,
              borderRadius: 2,
              overflow: "hidden",
              cursor: "default",
              minHeight: "80vh",
            }}
          >
            <PanoramaxViewer
              address={address}
              style={{ width: "100%", height: "100%" }}
            />
          </Box>
        </Box>
      )}
    </>
  );
}
